// extracted by mini-css-extract-plugin
export default {"controls":"UzERS","monthControls":"J8RsP","monthButton":"CxdGU","back":"ABO6J","month":"HfQUQ","loading":"n9zqc","next":"pOUt0","days":"t6FsH"};